import React, {Component} from 'react';
import Footer from './footer'
import {Link, browserHistory} from 'react-router';
import './css/terms.css';
import './css/toast_custom.css';

import Toast from './components/toast'


export default class Top extends Component {

  constructor() {
    super();
    this.state = {
      modalIsOpen: false,
      showTerms: false,
      isTerms: false,
      checkClass: "rc-checkbox",

      isToast:false
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

// モーダルを開く
  openModal() {
    this.setState({modalIsOpen: true});
  }

// モーダルを閉じる
  closeModal() {
    this.setState({modalIsOpen: false});
  }


  // onload
  componentDidMount() {
    // 本番URLかつLP期間中のみLPに強制リダイレクト
    var release_dt = new Date("Thu, 22 Feb 2018 16:00:00 +0900");
    var now_dt = new Date();
    //console.log(release_dt.getTime());
    //console.log(now_dt.getTime());
    if ("myrate.jp" === document.domain && "/" === window.location.pathname && release_dt.getTime() > now_dt.getTime()) {
      browserHistory.push("/lp");
    }
  //}

  //componentWillMount = () => {
    const {
      location
    } = this.props

    this.setState({isToast:false})

    if(typeof location.state !== 'undefined') {
      if(Object.keys(location.state).length <= 0) return

      if(!location.state.isUser && location.state.hasOwnProperty('isUser')) {
        this.setState({isToast: 'isUser' })
      }

      window.sessionStorage.clear()
      browserHistory.replace({
        pathname:"/",
        state:null
      })
      return
    } else if(location.search) {
      let params = location.search.replace('?','').split('=')
      if(params[0] === 'deleteComplete' && params[1] === 'true') {
        this.setState({isToast: 'deleteComplete' })
      }
    }
  }

  returnToast = () => {
    const {
      isToast
    } = this.state

    if(isToast) {
      let message
      if(isToast === 'isUser') {
        message = (<div className="toast-caution"><p>MyRateのアカウントが存在しません。</p><p>ご登録をお願いします。</p></div>)
      } else if(isToast === 'deleteComplete') {
        message = (<div className="toast-caution"><p>アカウントの削除が完了しました。</p></div>)
      }
      return (
        <Toast notifyMessage={message} />
      )
    }
  }

  render() {
  return(
    <div>
      <link href="css/top.css" rel="stylesheet" type="text/css"/>
      {this.returnToast()}
      <div id="wrapper" className="wrapper-lp wrapper-top">
        <div className="header">
          <img className="header-title" src="/img/lp/logo_white.png" alt="" />
          <Link to="/lplogin"><span className="header-login">ログイン</span></Link>
        </div>
        <div className="webWrap top-webWrap">
          <div className="wrapCover">
            <div className="wrapCover__lp-leadBlock clearfix">
              <div className="leadBlock-left">
                <img className="deviceImg__pc pc-only" src="/img/lp/img_device_pc.png" alt="" />
              </div>
              <div className="leadBlock-right">
                <div className="formBlock">
                  <p className="title">マイレートは、<br />オンラインの信頼証明書です。</p>
                  <img className="deviceImg__sp sp-only" src="/img/lp/img_device_sp.png" alt="" />
                  <Link to="/newflow1" className="btn-issue"><p>登録して証明書を発行する<br /></p></Link>
                  <Link to="/lplogin" className="btn-login" onClick={this.checkIsUser}><p>証明書をお持ちの方はここからログイン</p></Link>
                </div>
              </div>
            </div>
            <div className="wrapCover__lp-contentBlock clearfix">
              <h2>例えばこんな時に</h2>
              <div className="contentService clearfix">
                <div className="contentService-block">
                  <div className="detailBlock">
                    <img className="serviceImg__1" src="/img/top/top-box.png" alt="" />
                    <p className="title">商品を売買する時</p>
                  </div>
                  <div className="detailBlock">
                    <img className="serviceImg__1" src="/img/top/top-house.png" alt="" />
                    <p className="title">部屋を貸し借りする時</p>
                  </div>
                  <div className="detailBlock">
                    <img className="serviceImg__1" src="/img/top/top-car.png" alt="" />
                    <p className="title">車を貸し借りする時</p>
                  </div>
                </div>
              </div>

              <div className="contentService">
                <div className="detailBlock">
                  <h2>あなたの取引をサポートします</h2>
                  <img className="serviceImg__2" src="/img/lp/img_service_1.png" alt="" />
                  <p className="title f-blue">MyRateが、<br />オンラインの信頼力を証明！!</p>
                  <p className="text-detail">MyRateは身分証明書や電話番号の登録、シェアリングエコノミーサービスでの取引履歴の連携によって、あなたのオンラインの信用度を見える化します。</p>
                </div>
              </div>

              <hr className="border" />
              <h2>MyRateの使い方</h2>
              <div className="contentService contentService_2 clearfix">
                <div className="contentService-block">
                  <div className="detailBlock">
                    <img className="serviceImg__1" src="/img/top/top-nomber-1.png" alt="" />
                    <p className="title">MyRateに身分証明書や電話番号、<br className="sp-only"/>すでにお使いのサービスの信用情報を登録</p>
                  </div>
                  <div className="detailBlock">
                    <img className="serviceImg__1" src="/img/top/top-nomber-2.png" alt="" />
                    <p className="title">あなたのMyRateのURLをシェアリ<br className="sp-only"/>ングエコノミーでの取引時にシェア</p>
                  </div>
                  <div className="detailBlock">
                    <img className="serviceImg__1" src="/img/top/top-nomber-3.png" alt="" />
                    <p className="title">まだ信用が蓄積できていないサービ<br className="sp-only"/>スでの取引も有利になります</p>
                  </div>
                </div>
              </div>
              <hr className="border" />
              <div className="contentService-bottom">
                <div className="formBlock-bottom">
                  <h2>無料でMyRateを取得しよう！</h2>
                  <img className="serviceImg__3" src="/img/lp/img_service_2.png" alt="" />
                  <p className="sub-title">登録は4ステップですぐに完了します。</p>
                  <Link to="/newflow1" className="btn-register"><p>証明書を発行する</p></Link>
                </div>
              </div>
            </div>
            <Footer/>
          </div>
        </div>
      </div>
    </div>
  )
 }
}




// WEBPACK FOOTER //
// ./src/top.js